<template lang="pug">
vm-row( class="details" vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
    div
      h2 {{ $t('strings.purchase_order') }}
      span order
  vm-row(vm-w="12")
    vm-col.card(vm-sm=12)
      vm-table(multiple v-model="selectedProducts" max-items="10" pagination max-height="350px" :data="form.details" )
        template(slot="header")
          div
            h4 {{ $t('requisitions_mailboxes.filter') }}
          vm-row(vm-w="12" class="details__filters")
            vm-col(vm-w=10)
              vm-input(class="details__filters-search" ref="search" icon="search" v-model="searchParam" @keyup.enter="onSearch" width="80%")
            vm-col(vm-w=2)
              vm-button(class="btn-requisitions" @click="deleteShipping")
                  vm-icon(icon="trash-2-outline")
        template(slot="thead")
          vm-th(:key="index" v-for="(column, index) in columns") {{ $t('requisitions_mailboxes.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-for="(column, index) in columns")
              slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
              slot(v-if="column == 'supply'")  {{ data[indextr][column]['sku'] }}
              vm-input(type="currency" value="1" v-if="column == 'unit_price'"  v-model="data[indextr].unit_price")
              vm-input(disabled type="currency" v-if="column == 'total'" v-model="data[indextr].supply_pending_quantity * data[indextr].unit_price")
              slot(v-if="column != 'status' && column != 'remaining' && column != 'supply' && column != 'created_at' && column != 'unit_price' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
              slot(v-if="column == 'action'")
                vm-button.actions_products(type="flat" vm-size="sm" @click="deleteProduct(data[indextr], tr)" icon="close-circle-outline")
      transition(name="enter")
        .total-products(v-if="total>0") Total de productos: {{ purchaseOrder.details.length }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')
export default {
  name: 'DetailsPurcharseOrder',
  components: {},
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'supply', 'supply_unit', 'supply_pending_quantity', 'unit_price', 'total', 'action'],
    selectedProducts: [],
    total: 1,
    searchParam: '',
    form: {
      details: []
    }
  }),
  computed: {
    ...mapGetters(['purchaseOrder'])
  },
  watch: {
    'purchaseOrder.details' (datas) {
      this.form = { ...this.purchaseOrder }
    }
  },
  async created () {
    await this.setPurchase([])
  },
  methods: {
    ...mapActions([
      'loadPurcharse',
      'deletedProductDetails',
      'deletedProductsDetails',
      'setPurchase'
    ]),
    onSearch () {
      this.searchParam ? this.form.details = Array(...this.purchaseOrder.details.filter(deatil => deatil.supply.sku.toLowerCase().includes(this.searchParam.toLowerCase()))) : this.form = { ...this.purchaseOrder }
    },
    async deleteShipping () {
      await this.deletedProductsDetails([ ...this.selectedProducts ])
      this.selectedProducts = []
    },
    deleteProduct (data) {
      this.deletedProductDetails(data)
    }
  }
}
</script>
<style lang="scss">
.details {
  .card {
    margin-top: 10px;
    border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
    padding: 20px !important;
    box-shadow: none !important;
    header {
      span {
        width: 100%;
        .vm-con-input-label {
          margin: 10px 0;
        }
      }
    }
  }
  &__filters {
    display: flex;
    justify-content: space-between;
    &__filters-search {
      border: 1px solid rgba($color: var(--gray), $alpha: 1.0);
      border-radius: 10px;
      margin: 10px 0;
    }
    .vm-button {
      background-color: white !important;
      color: #929292;
      padding: 0 !important;
      width: 50px;
      height: 50px;
      box-shadow: none !important;
      margin-left: 10px;
      vm-icon {
        width: 30px;
      }
    }
  }
}
</style>
